import { patientOptionsService } from '@/services/patient-options-service'
import { GET_DIAGNOSES, SET_DIAGNOSES } from '@/store/mutation-types'

import { normalize } from 'normalizr'
import { schemas } from '@/store/schemas'

export const mutations = {
  [SET_DIAGNOSES](state, diagnosesData) {
    const diagnoses = normalize(diagnosesData, schemas.diagnosisData)

    state.diagnoses = diagnoses.entities.diagnoses
    state.diagnosisHistologies = diagnoses.entities.diagnosisHistologies
    state.diagnosisSites = diagnoses.entities.diagnosisSites
    state.diagnosisStages = diagnoses.entities.diagnosisStages
    state.diagnosisGrades = diagnoses.entities.diagnosisGrades
    state.metastases = diagnoses.entities.metastases
  }
}

export const actions = {
  async [GET_DIAGNOSES]({ commit }) {
    const response = await patientOptionsService.getDiagnosisData()
    commit(SET_DIAGNOSES, response.data)
    return response.data
  }
}
